import { VcenterWebComponent } from './component/VcenterWebComponent';
import { WEB_COMPONENT_VCENTER } from '../../../webcomponents.constants';

export { VcenterWebComponent };

window.customElements.define(WEB_COMPONENT_VCENTER, VcenterWebComponent);
